module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.goVideoCategories()
      }
    }
  }, [_vm._v("戻る")])])]), _c('section', {
    staticClass: "content"
  }, [_c('dl', {
    staticClass: "container"
  }, [_c('dt', [_vm._v("接客と接遇について")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M6.mp4",
      "poster": _vm.poster('M6'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("正しい立ち姿と第一印象")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M7.mp4",
      "poster": _vm.poster('M7'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("挨拶Ⅰ　～意味　言語・聴覚・視覚情報～")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M8.mp4",
      "poster": _vm.poster('M8'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("挨拶Ⅱ　～お辞儀～")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M9.mp4",
      "poster": _vm.poster('M9'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("挨拶Ⅲ　～職場でのおあしも～")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M10.mp4",
      "poster": _vm.poster('M10'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("接客の距離感と位置・ものの受け渡し")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M11.mp4",
      "poster": _vm.poster('M11'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("ホールラウンド・優先動作・左右確認")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M12.mp4",
      "poster": _vm.poster('M12'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("お客様対応・お声がけ動作・周囲への配慮")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M13.mp4",
      "poster": _vm.poster('M13'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("インカムの使い方・注意点")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M14.mp4",
      "poster": _vm.poster('M14'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])]), _c('dt', [_vm._v("清掃時の注意点　ゴミ回収・灰皿回り")]), _c('dd', {
    staticClass: "divider"
  }, [_c('a', {
    staticClass: "video__list__item__wrap"
  }, [_c('div', {
    staticClass: "video__list__item__wrap__content"
  }, [_c('video', {
    attrs: {
      "src": "../../static/videos/M15.mp4",
      "poster": _vm.poster('M15'),
      "controls": "",
      "controlsList": "nodownload"
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5ad872ce!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/video-customer-service.pug
// module id = 1398
// module chunks = 1